import { render, staticRenderFns } from "./TaskWorkflows.vue?vue&type=template&id=428f7ac3&scoped=true&"
import script from "./TaskWorkflows.vue?vue&type=script&lang=js&"
export * from "./TaskWorkflows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428f7ac3",
  null
  
)

export default component.exports